import { Button, Modal, Space, Spin, Table, TableProps, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { PortalListingSyncProperties } from "../../../types/portalListing.type";
import NotSet from "../../../components/NotSet";
import { formatYearToTime } from "../../../helpers/format";
import ReactJson from "react-json-view";
import useFetchList from "../../../hooks/useFetchList";
import CustomPagination from "../../../components/CustomPagination";
import { httpRequest } from "../../../helpers/api";
import { R123_PORTAL_ID } from "../../employee/constant";

interface IProps {
	title: string;
	open: boolean;
	onClose: () => void;
	listingId: string;
	portalId?: string;
}
export default function PortalSyncLogModal(props: IProps) {
	const portalId = props.portalId || R123_PORTAL_ID;
	const isRumah123 = portalId === R123_PORTAL_ID;
	const [requestData, setRequestData] = useState<any>();
	const [responsePortalData, setResponsePortalData] = useState<any>();
	const [trxId, setTrxId] = useState("");
	const [resTrxStatus, setResTrxStatus] = useState<any>();
	const [isLoadingGetTrx, setIsLoadingGetTrx] = useState(false);

	const { isLoading, data, pagination, changePage, setQuery, query } = useFetchList<PortalListingSyncProperties, any>(
		{
			endpoint: "portal-listing-syncs",
			fetchable: props.open,
			initialQuery: {
				filterListingId: props.listingId,
				filterPortalId: portalId,
			},
			limit: 10,
		}
	);

	useEffect(() => {
		if (props.listingId) {
			setQuery({
				...query,
				filterListingId: props.listingId,
				filterPortalId: portalId,
			});
		}
	}, [props.listingId, portalId]);

	useEffect(() => {
		if (data && data.length > 0) {
			console.log("[PortalSyncLogModal] Portal sync data:", data);
			data.forEach((item, idx) => {
				console.log(`[PortalSyncLogModal] Record ${idx}:`, {
					action: item.action,
					result: item.result,
					status: item.status,
					message: item.resultData?.message,
					resultData: item.resultData,
					metadata: item.metadata,
				});
			});
		}
	}, [data]);

	useEffect(() => {
		if (trxId) {
			(async () => {
				setIsLoadingGetTrx(true);
				try {
					const res = await httpRequest.get<any>(`rumah123/status-by-trxid/${trxId}`);
					setResTrxStatus(res.data.payload);
				} catch (error) {
					console.log(error);
				} finally {
					setIsLoadingGetTrx(false);
				}
			})();
		} else {
			setTrxId("");
			setResTrxStatus(undefined);
		}
	}, [trxId]);

	const COLUMNS: TableProps<PortalListingSyncProperties>["columns"] = [
		{
			title: "ACTION LISTING",
			key: "action",
			dataIndex: "action",
			width: 120,
			render: (value: string) => value || <NotSet />,
		},
		{
			title: "RESULT STATUS",
			key: "result",
			dataIndex: "result",
			width: 120,
			render: (value: string) => value || <NotSet />,
		},
		{
			title: "SYNC STATUS",
			key: "status",
			dataIndex: "status",
			width: 120,
			render: (value: string) => value || <NotSet />,
		},
		{
			title: "Message",
			key: ["resultData", "message"],
			dataIndex: ["resultData", "message"],
			width: 170,
			render: (value: string) => value || <NotSet />,
		},
		{
			title: "TRX ID",
			key: ["resultData", "trx_id"],
			dataIndex: ["resultData", "trx_id"],
			width: 150,
			hidden: !isRumah123,
			render: (value: string) =>
				value ? (
					<Space
						direction="vertical"
						size={4}
						style={{ width: "max-content" }}
					>
						<Typography.Text>{value}</Typography.Text>
						<Button onClick={() => setTrxId(value)}>See Detail</Button>
					</Space>
				) : (
					<NotSet />
				),
		},
		{
			title: "REQUEST DATA",
			key: "requestData",
			dataIndex: "requestData",
			width: 250,
			render: (value: any) => {
				return (
					<Button
						onClick={() => {
							setRequestData(value);
						}}
					>
						See JSON
					</Button>
				);
			},
		},
		{
			title: "RESULT LISTING PORTAL",
			key: "resultData",
			dataIndex: "resultData",
			width: 250,
			render: (value: any, record: PortalListingSyncProperties) => {
				let data = {
					portalResponse: value,
					internalMetadata: {
						...record.metadata,
					},
				};
				if (isRumah123) {
					if (record?.metadata?.sendResponseR123At) {
						data.internalMetadata.sendResponseR123At = formatYearToTime(record.metadata?.sendResponseR123At);
					}
					if (record?.metadata?.errorResponseR123At) {
						data.internalMetadata.errorResponseR123At = formatYearToTime(record.metadata?.errorResponseR123At);
					}
				}
				return (
					<div>
						<Button
							onClick={() => {
								setResponsePortalData(data);
							}}
						>
							See JSON
						</Button>
					</div>
				);
			},
		},

		// {
		// 	title: "RESULT FROM PORTAL",
		// 	key: "resultData",
		// 	dataIndex: "resultData",
		// 	width: `${100 / columnLength}%`,
		// 	render: (resultData: any) => (
		// 		<Button
		// 			onClick={() => {
		// 				setDetailResultPortal(resultData);
		// 			}}
		// 		>
		// 			Show JSON
		// 		</Button>
		// 	),
		// },
		{
			title: "CREATED AT",
			key: "createdAt",
			dataIndex: "createdAt",
			width: 120,
			render: (value: string) => formatYearToTime(value) || <NotSet />,
		},
	].filter(Boolean) as TableProps<PortalListingSyncProperties>["columns"];

	return (
		<>
			<Modal
				width="80%"
				title={props.title}
				footer={null}
				open={props.open}
				destroyOnClose={true}
				onCancel={() => {
					props.onClose();
				}}
				style={{ zIndex: 1000 }}
			>
				<Space direction="vertical">
					<Table
						loading={isLoading}
						columns={COLUMNS}
						dataSource={data}
						rowKey="portalListingSyncId"
						pagination={false}
						scroll={{ x: "100%" }}
					/>
					<CustomPagination
						current={pagination.page}
						total={pagination.totalData}
						defaultPageSize={pagination.perPage}
						pageSize={pagination.perPage}
						onChange={changePage}
					/>
				</Space>
			</Modal>

			<Modal
				title="Portal Request Data"
				width={750}
				open={!!requestData}
				closable
				footer={false}
				onCancel={() => {
					setRequestData(undefined);
				}}
				bodyStyle={{ padding: "24px 32px" }}
				style={{ maxHeight: "80vh", overflowY: "auto", zIndex: 1001 }}
			>
				<Space
					direction="vertical"
					style={{ width: "100%" }}
				>
					<div
						style={{
							maxHeight: "65vh",
							overflowY: "auto",
							border: "1px solid #f0f0f0",
							borderRadius: 4,
							padding: 8,
							backgroundColor: "#fafafa",
						}}
					>
						<ReactJson
							src={requestData || {}}
							name={false}
							enableClipboard={false}
							displayDataTypes={false}
							collapsed={false}
							style={{ fontSize: 12 }}
						/>
					</div>
				</Space>
			</Modal>

			{isRumah123 && <Modal
				title="Trx Status Rumah123"
				width={750}
				open={!!trxId}
				closable
				footer={false}
				onCancel={() => {
					setTrxId("");
					setResTrxStatus(undefined);
				}}
				bodyStyle={{ padding: "24px 32px" }}
				style={{ maxHeight: "80vh", overflowY: "auto", zIndex: 1001 }}
			>
				<Spin spinning={isLoadingGetTrx}>
					<Space
						direction="vertical"
						style={{ width: "100%" }}
					>
						<div
							style={{
								maxHeight: "65vh",
								overflowY: "auto",
								border: "1px solid #f0f0f0",
								borderRadius: 4,
								padding: 8,
								backgroundColor: "#fafafa",
							}}
						>
							<ReactJson
								src={resTrxStatus || {}}
								name={false}
								enableClipboard={false}
								displayDataTypes={false}
								collapsed={false}
								style={{ fontSize: 12 }}
							/>
						</div>
					</Space>
				</Spin>
			</Modal>}

			<Modal
				title="RESULT LISTING PORTAL"
				width={750}
				open={!!responsePortalData}
				closable
				footer={false}
				onCancel={() => {
					setResponsePortalData(undefined);
				}}
				bodyStyle={{ padding: "24px 32px" }}
				style={{ maxHeight: "80vh", overflowY: "auto", zIndex: 1001 }}
			>
				<Space
					direction="vertical"
					style={{ width: "100%" }}
				>
					<div
						style={{
							maxHeight: "65vh",
							overflowY: "auto",
							border: "1px solid #f0f0f0",
							borderRadius: 4,
							padding: 8,
							backgroundColor: "#fafafa",
						}}
					>
						<ReactJson
							src={responsePortalData || {}}
							name={false}
							enableClipboard={false}
							displayDataTypes={false}
							collapsed={false}
							style={{ fontSize: 12 }}
						/>
					</div>
				</Space>
			</Modal>
		</>
	);
}
